"use client"

import { Button } from "@components/react/pricing/ui/button"
import { ArrowRight } from "lucide-react"
import { motion } from "framer-motion"

interface PlanSelectButtonProps {
  planName: string
  onClick: () => void
}

export function PlanSelectButton({ planName, onClick }: PlanSelectButtonProps) {
  return (
    <motion.div whileHover={{ scale: 1.02 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
      <Button
        className="w-full max-w-[180px] bg-[#3037e2] hover:bg-[#2731c8] text-white rounded-full py-3 px-6 h-auto group"
        onClick={onClick}
      >
        <span>Get Custom Quote</span>
        <ArrowRight className="ml-1 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
      </Button>
    </motion.div>
  )
}
